module.exports = __webpack_public_path__ + "img/scene-energy.bb956847.jpg";